export default function Slug() {
  return null;
}
